import clsx from "clsx";
import InlineSvg from "../../../InlineSvg";
import { Label5 } from "../../../typography/components/Label";

type UtilityTabBadgeProps = {
  name: string;
  assetUrl: string;
  assetDescription: string;
};
const UtilityTabBadge = ({
  name,
  assetUrl,
  assetDescription,
}: UtilityTabBadgeProps) => {
  return (
    <div
      key={name}
      className={clsx(
        "laptop:gap-3 flex min-w-[80px] snap-start flex-col items-center",
      )}
    >
      <InlineSvg
        className={clsx("laptop:w-[72px] w-[51px]")}
        asset={{ url: assetUrl, description: assetDescription }}
      />
      <Label5 className="w-max font-mono text-xs">{name}</Label5>
    </div>
  );
};

export default UtilityTabBadge;
